/* Green Gorilla Fruits — login return path
 * --------------------------------------------------------------
 * New customer accounts (OAuth) drops any `return_url` passed to
 * /account/login, so we round-trip the origin path via
 * sessionStorage and redirect once we land on the post-auth
 * callback (/account or /customer_authentication/redirect).
 */
(function () {
  'use strict';

  const KEY = 'gg_login_return_path';
  const LANDING_RE = /^\/(account(?:$|\/)|customer_authentication\/redirect(?:$|\/))/;
  const SKIP_SAVE_RE = /^\/(account|customer_authentication)(?:$|\/)/;

  function save() {
    if (SKIP_SAVE_RE.test(location.pathname)) return;
    try {
      sessionStorage.setItem(KEY, location.pathname);
    } catch (_) {
      /* sessionStorage unavailable */
    }
  }

  function consume() {
    if (!LANDING_RE.test(location.pathname)) return;
    let saved;
    try {
      saved = sessionStorage.getItem(KEY);
    } catch (_) {
      return;
    }
    if (!saved) return;
    try {
      sessionStorage.removeItem(KEY);
    } catch (_) {
      /* ignore */
    }
    if (typeof saved !== 'string' || saved[0] !== '/' || saved.startsWith('//')) return;
    if (saved === location.pathname) return;
    location.replace(saved);
  }

  document.addEventListener(
    'click',
    (e) => {
      const target = e.target;
      if (!target || typeof target.closest !== 'function') return;
      if (target.closest('[data-gg-login-return]')) save();
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', consume);
  } else {
    consume();
  }
})();
